<template>
    <div class="container">
        <div class="row justify-content-md-center">
            <div class="col col-lg-2">
            </div>
            <div class="col-md-auto">
                <calendar-form ref="calendarForm" v-bind:backEnable="true" v-bind:calendarErrorType="this.calendarErrorType" @save-calendar-data="saveCalendarData" />
            </div>
            <div class="col col-lg-2">
            </div>
        </div>
    </div>
</template>

<script>
import Team from '../models/Team.js'
import CalendarForm from '../components/CalendarForm.vue'

export default {
    components: {
        CalendarForm
    },
    data: function() {
        return {
            team: null,
            calendarId: null,
            apiKey: null,
            calendars: null,
            calendarErrorType: 0
        }
    },
    props: {
        ownerId: String
    },
    methods: {
        saveCalendarData: function(calendarId, apiKey) {
            let that = this
            console.info(`emit register calendar: ${calendarId}, apiKey: ${apiKey}`)
            that.team.calendarId = calendarId
            that.team.apiKey = apiKey
            that.team.update();

            that.$router.push({
                name: 'console',
                params: {
                    ownerId: that.team.ownerId
                }
            })
        }
    },
    created: async function() {
        let team = await Team.findByOwnerId(this.ownerId)
        
        if (team) {
            this.team = team
            this.calendarId = team ? team.calendarId : null
            this.apiKey = team ? team.apiKey : null
            this.$refs.calendarForm.setDefaultData(this.calendarId, this.apiKey)
        }
    },
}
</script>
